<template>
  <div id="app">
    <Sidebar v-if="$route.meta.showSidebar !== false" />
    <router-view></router-view>
  </div>
</template>

<script>
import Sidebar from './components/Sidebar.vue'

export default {
  components: {
    Sidebar
  }
}
</script>

<style lang="less">
#app{
  display: flex;
}

body{
  padding: 0;
  margin: 0;
}
</style>
